module.exports = __webpack_public_path__ + "static/media/paradise-1110498_640.c0f0313b.jpg";